module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.modal_title)), _vm._m(0)]), _c('div', {
    staticClass: "modal-body",
    style: ({
      maxHeight: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "task-form"
  }, [_c('div', {
    staticClass: "col-xl-8 col-md-7 col-sm-5 col-xs-12",
    attrs: {
      "id": "other_options"
    }
  }, [(_vm.can_change_contact) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contato"), _c('span', {
    staticClass: "spacer-5"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-pencil clickable",
    on: {
      "click": function($event) {
        return _vm.$emit("change-contact", {
          contact: null
        })
      }
    }
  })]), _c('input', {
    staticClass: "form-control text-gray-color",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.contact.full_name
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('task_service')
    }
  }, [_c('label', [_vm._v("Tipo de Tarefa")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.service),
      expression: "task.service"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-email-task': _vm.task.isEmailTask()
    },
    attrs: {
      "name": "task_service"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.availableManualTaskServices), function(service_options) {
    return _c('option', {
      domProps: {
        "value": service_options.service
      }
    }, [_vm._v(_vm._s(service_options.human_name))])
  }), 0), (_vm.task.isEmailTask()) ? _c('div', {
    staticClass: "button-email",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Ir para e-mail"
    },
    on: {
      "click": _vm.emitOpenTemplateModalEvent
    }
  }) : _vm._e(), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task_service')),
      expression: "errors.has('task_service')"
    }],
    key: "task_service",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('task_service')))])])], 1), (!_vm.show_meeting_task) ? _c('div', {
    staticClass: "form-group due-on-time-picker-wrapper",
    class: {
      'has-error': _vm.errors.has('due_on_time')
    }
  }, [_c('label', [_vm._v("Horário")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('regex:^([0-2][0-9]:[0-5][0-9])$'),
      expression: "'regex:^([0-2][0-9]:[0-5][0-9])$'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.due_on_time),
      expression: "due_on_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "due_on_time",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.due_on_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.due_on_time = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('due_on_time')),
      expression: "errors.has('due_on_time')"
    }],
    key: "due_on_time",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('due_on_time')))])])], 1) : _vm._e(), (_vm.show_meeting_task) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('meeting_type_id')
    }
  }, [_c('label', [_vm._v("Tipo de Reunião")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.meeting_type_id),
      expression: "task.meeting_type_id"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-email-task': _vm.task.isEmailTask()
    },
    attrs: {
      "disabled": _vm.meeting_types.length == 0,
      "name": "meeting_type_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "meeting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.meeting_types), function(meeting_type) {
    return _c('option', {
      domProps: {
        "value": meeting_type.id
      }
    }, [_vm._v(_vm._s(meeting_type.title))])
  }), 0), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('meeting_type_id')),
      expression: "errors.has('meeting_type_id')"
    }],
    key: "meeting_type_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('meeting_type_id')))]), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meeting_types.length == 0),
      expression: "meeting_types.length == 0"
    }],
    key: "meeting_type_empty",
    staticClass: "link-no-meeting-types",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.toActivities
    }
  }, [_vm._v("Você não possui nenhum tipo de reunião cadastrado")])])], 1) : _vm._e(), (_vm.show_meeting_task) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Responsável")]), _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "options": _vm.users_options
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "col-xl-4 col-md-5 col-sm-6 col-xs-12",
    attrs: {
      "id": "calendar_choice"
    }
  }, [_c('div', {
    staticClass: "datepicker-wrapper"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Selecione a data")]), _c('datepicker', {
    attrs: {
      "inline": true,
      "disabled": {
        to: _vm.yesterday
      },
      "language": "pt-br"
    },
    model: {
      value: (_vm.due_on_date),
      callback: function($$v) {
        _vm.due_on_date = $$v
      },
      expression: "due_on_date"
    }
  })], 1)]), (_vm.show_meeting_task) ? _c('div', {
    staticClass: "form-group due-on-time-picker-wrapper",
    class: {
      'has-error': _vm.errors.has('due_on_time'), 'has-error': _vm.errors.has('end_on_time')
    }
  }, [_c('label', [_vm._v("Horário")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('regex:^([0-2][0-9]:[0-5][0-9])$'),
      expression: "'regex:^([0-2][0-9]:[0-5][0-9])$'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.due_on_time),
      expression: "due_on_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "due_on_time",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.due_on_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.due_on_time = $event.target.value
      }
    }
  }), (_vm.show_meeting_task) ? _c('span', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("às")]) : _vm._e(), (_vm.show_meeting_task) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('regex:^([0-2][0-9]:[0-5][0-9])$'),
      expression: "'regex:^([0-2][0-9]:[0-5][0-9])$'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.end_on_time),
      expression: "end_on_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "end_on_time",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.end_on_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_on_time = $event.target.value
      }
    }
  }) : _vm._e(), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('due_on_time') || _vm.errors.has('end_on_time')),
      expression: "errors.has('due_on_time') || errors.has('end_on_time')"
    }],
    key: "due_on_time",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('due_on_time') || _vm.errors.first('end_on_time')))])])], 1) : _vm._e()])]), _c('div', {
    staticClass: "task-form"
  }, [(_vm.show_meeting_task) ? _c('div', {
    staticClass: "form-group full-width",
    class: {
      'has-error': _vm.errors.has('email_invites')
    }
  }, [_c('label', [_vm._v("Enviar invites para")]), _c('div', {
    staticClass: "cc-wrapper"
  }, [_c('div', _vm._l((_vm.email_invites), function(item, index) {
    return _c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(item.email)), _c('div', {
      staticClass: "remove-email glyphicon glyphicon-remove",
      on: {
        "click": function($event) {
          return _vm.removeEmail(index)
        }
      }
    })])
  }), 0), _c('div', [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.email_invites.length < 10),
      expression: "email_invites.length < 10"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cc_text),
      expression: "cc_text"
    }],
    staticClass: "form-control cc",
    domProps: {
      "value": (_vm.cc_text)
    },
    on: {
      "blur": _vm.blurCc,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cc_text = $event.target.value
      }
    }
  })])]), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email_invites')),
      expression: "errors.has('email_invites')"
    }],
    key: "email_invites",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email_invites')))])])], 1) : _vm._e()]), _c('div', {
    staticClass: "task-form"
  }, [(_vm.show_meeting_task) ? _c('div', {
    staticClass: "form-group full-width",
    class: {
      'has-error': _vm.errors.has('social_link')
    }
  }, [_c('label', [_vm._v("Link para reunião")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.social_link),
      expression: "social_link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "social_link"
    },
    domProps: {
      "value": (_vm.social_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.social_link = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('social_link')),
      expression: "errors.has('social_link')"
    }],
    key: "social_link",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('social_link')))])])], 1) : _vm._e()]), _c('div', {
    staticClass: "task-form"
  }, [(_vm.show_stage_selection) ? _c('div', {
    staticClass: "form-group full-width",
    class: {
      'has-error': _vm.errors.has('new_stage')
    }
  }, [_c('label', [_vm._v("Selecione o novo estágio")]), _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "data-vv-name": "new_stage",
      "options": _vm.next_valid_stages
    },
    model: {
      value: (_vm.new_stage),
      callback: function($$v) {
        _vm.new_stage = $$v
      },
      expression: "new_stage"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_stage')),
      expression: "errors.has('new_stage')"
    }],
    key: "new_stage",
    staticClass: "help-block"
  }, [_vm._v("Favor selecionar o estágio")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "task-form"
  }, [_c('div', {
    staticClass: "form-group full-width",
    class: {
      'has-error': _vm.errors.has('comment')
    }
  }, [_c('label', [_vm._v("Comentário")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.comment),
      expression: "task.comment"
    }],
    staticClass: "form-control comment",
    attrs: {
      "name": "comment",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.task.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "comment", $event.target.value)
      }
    }
  })])]), (_vm.show_meeting_task) ? _c('div', {
    staticClass: "task-form"
  }, [_c('div', {
    staticClass: "form-group full-width"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": _vm.checkboxSendReminder
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.send_reminder
    }
  }), _c('label', [_vm._v("Enviar e-mail de lembrete da reunião")])])])]) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "task-actions"
  }, [_c('div', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")]), (_vm.task.isPersisted()) ? _c('div', {
    staticClass: "btn btn-danger no-margin",
    on: {
      "click": function($event) {
        return _vm.$emit("removing")
      }
    }
  }, [_vm._v("Excluir")]) : _vm._e(), (_vm.valid_due_on) ? _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.meeting_types.length == 0 && _vm.show_meeting_task
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Salvar")]) : _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v("Salvar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3442e1e2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/form.vue
// module id = 1074
// module chunks = 1